import { AppConfig, THEME } from '../configTypes';

const config: AppConfig = {
  broker_uid: '56d5d1b437bd94003808834c',
  logoSrc: '/logo-myfaro.png',
  heroImgSrc: '/myfaro-mobile.jpg',
  resultImg: '/graphic-myfaro.svg',
  baseName: '/leads/myfaro',
  desktopImg: '/myfaro-desktop.jpg',
  helpNeeded: false,
  theme: THEME.MYFARO,
  scenarios: [
    'retirementAge',
    'yearsBeforeRetirementAge',
    'desiredEndCapitalValue',
  ],
  additionalDomains: [],
  movableProperties: [
    {
      name: 'bankSavingsValue',
      label: 'what.bankSavingsValue',
      tooltipTitle: 'tooltip.savings',
    },
    {
      name: 'bankInvestmentsValue',
      label: 'what.bankInvestmentsValue',
      tooltipTitle: 'tooltip.investments',
    },
    {
      name: 'businessAssetsValue',
      label: 'what.businessAssetsValue',
      tooltipTitle: 'tooltip.businessAssetsValue',
    },
    {
      name: 'insuranceProtectionValue',
      label: 'what.insuranceProtectionValue2',
      tooltipTitle: 'tooltip.insuranceProtectionValue2',
    },
    {
      name: 'insuranceInvestmentsValue',
      label: 'what.insuranceInvestmentsValue',
      tooltipTitle: 'tooltip.insuranceInvestmentsValue',
    },
  ],
  immovableProperties: [
    {
      name: 'homeValue',
      label: 'what.ownHouse',
      tooltipTitle: 'tooltip.ownHouse',
    },
    {
      name: 'otherRealEstateValue',
      label: 'what.otherThanOwnHouse',
      tooltipTitle: 'tooltip.otherThanOwnHouse',
    },
  ],
  whoFields: [
    'name',
    'gender',
    'dateOfBirth',
    'zip_code',
    'socialStatus',
    'civilStatus',
    'hasOwnCompany',
    'hasDependentChildren',
  ],
  debtFields: [
    'liabilitiesValue',
    'liabilitiesRemainingAtRetirementInput',
    'monthlyExpensesLiabilitiesValue',
  ],
  showResultGraph: true,
  showLeadConfidence: true,
  // validations
};
export default config;
